<template>
  <div class="pa-2" id="topics">
    <!--タイトル-->
    <span class="subHead">
    {{ title }}
    </span>
    <v-icon
    class="mb-2"
    color="blue-grey darken-2">
      {{ icon }}
    </v-icon>
    <!--内容-->
          <div class="">
          <v-col v-for="(item, i) in contents"
      :key="i">
         <v-card-title class="descriptiontitle">
         <!--タイトル横アイコン-->
        <v-icon
        class="ml-2 mt-1">
        mdi-lightbulb
        </v-icon>
              {{ item.descriptiontitle }}
              </v-card-title>
              <v-card-text class="summary" style="white-space:pre-wrap; word-wrap:break-word; margin-top:-1rem;">
                {{ item.description }}
              </v-card-text>
              </v-col>
              </div>
  </div>
</template>

<style>
.subHead {
  font-size: 25px;
}
.head2 {
  font-size: 20px;
  border-left: inset 6px#99CCFF;
  padding-left: 8px;
  margin-bottom: 8px;
}
.summary {
  vertical-align: middle;
  font-size: 16px;
}
.descriptiontitle{
    font-size: 18px;
  color:#345fb5;
}
hr{
    max-width: 1200px;
}
</style>

<script>
export default {
  data () {
    return {
      // タイトル
      title: '導入するメリット',
      // タイトル横のアイコン
      icon: 'mdi-plus-circle-multiple',
      contents: [
        {
          // 説明タイトル
          descriptiontitle: '処置の効率化',
          // 説明文
          description: `
予約枠に次回の処置を登録することができるため、歯科医院では当日の治療の概要が把握でき、効率的に治療を行うことができるようになります。重い処置が必要な場合は、重ならないように予約枠を調整したり、技工物がある場合に完成日より前の日に予約を取ることを防止できるようになります。`
        },
        {
          // 説明タイトル2
          descriptiontitle: 'リコールの通知',
          // 説明文2
          description: `
次の治療までの期間が長くなる場合は、リコールに登録しておくことで期日の近づいた患者を一覧できるようになります。`
        },
        {
          // 説明タイトル3
          descriptiontitle: '無断キャンセルの減少',
          // 説明文3
          description: `
歯科医院では、患者は治療が継続する場合、会計時に次回予約をとり、痛みだした場合は電話で予約をとられますが、予約システムを導入することによって、患者は次の予約をスマホ等で確認できるようになり、システムからのお知らせメールを受け取ることでうっかり忘れを減らすことができるようになります。また次の予約日に都合が悪くなった場合でも、歯科医院に電話することなく、キャンセルして予約日の変更できるため、無断キャンセルを減らせるようになります。`
        },
        {
          // 説明タイトル4
          descriptiontitle: '無断キャンセル患者の把握',
          // 説明文4
          description: `
受付を行わなかった場合に無断キャンセルとなり、過去の履歴から無断キャンセルの履歴がわかるようになります。`
        }
      ]
    }
  }
}
</script>
